import React from "react";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import { Table } from "reactstrap";

const Totals = ({ totals }) => {
  return (
    <Table>
      <thead>
        <tr>
          <th>Exchange</th>
          <th className="text-right">FX Rate</th>
          <th className="text-right">Total USD</th>
          <th className="text-right">Total</th>
        </tr>
      </thead>
      <tbody>
        {totals.map((item, index) => (
          <tr key={`totals-${index}`}>
            <td>
              {item.ShortCoverTotalDivides
                ? `${item.ShortCoverTotalISO} / ${item.ShortCoverTotalFromISO}`
                : `${item.ShortCoverTotalFromISO} / ${item.ShortCoverTotalISO}`}
            </td>
            <td className="text-right">
              <FormattedNumber value={item.ShortCoverTotalFX} dataTypeDecimalName="currency" />
            </td>
            <td className="text-right">
              <FormattedNumber
                value={
                  item.ShortCoverTotalDivides
                    ? item.ShortCoverTotal * item.ShortCoverTotalFX
                    : item.ShortCoverTotal / item.ShortCoverTotalFX
                }
                dataTypeDecimalName="currency"
              />
            </td>
            <td className="text-right">
              <FormattedNumber value={item.ShortCoverTotal} dataTypeDecimalName="currency"/>{" "}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default Totals;
